'use client'

import { serviceType } from '@/lib/service/server'
import { useSearchParams } from 'next/navigation'
import React from 'react'

type SortButtonProps = {
  service: serviceType
}

export const SortButton: React.FC<SortButtonProps> = () => {
  const searchParams = useSearchParams()
  const sort = searchParams.get('key') || 'default'

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const currentUrl = new URL(window.location.href)
    const value = e.target.value

    if (value === 'default') {
      currentUrl.searchParams.delete('key')
    } else {
      currentUrl.searchParams.set('key', value)
    }

    window.location.href = currentUrl.href
  }

  return (
    <div className="text-sm">
      <select
        value={sort}
        onChange={handleSortChange}
        className="sort-button button-color main-color text-white py-2 px-2 rounded-md"
      >
        <option value="default">人気順</option>
        <option value="low">価格が安い順</option>
        <option value="new">新着順</option>
      </select>
    </div>
  )
}
